import { render, staticRenderFns } from "./PasienCheckIn.vue?vue&type=template&id=6a630326"
import script from "./PasienCheckIn.vue?vue&type=script&lang=js"
export * from "./PasienCheckIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a630326')) {
      api.createRecord('6a630326', component.options)
    } else {
      api.reload('6a630326', component.options)
    }
    module.hot.accept("./PasienCheckIn.vue?vue&type=template&id=6a630326", function () {
      api.rerender('6a630326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/PasienCheckIn.vue"
export default component.exports